module.exports = __webpack_public_path__ + "static/img/6.4255f32c.png";